import angular from 'angular';
import savedInsuranceProfilers from './savedInsuranceProfilers';

export default angular
  .module('clientInsurance.scenes.savedInsuranceProfilers', [])
  .component('savedInsuranceProfilers', savedInsuranceProfilers).name;
